// Path: ./src/app/components/SearchInputField/styled.ts
import styled from "styled-components";
import { styled as MuiStyled, TextField } from "@mui/material";
export const StyledTextField = MuiStyled(TextField)({
  "& .MuiInputBase-root": {
    borderRadius: 10,
    backgroundColor: "white",
    paddingRight: 4,
    // width: 680,
    "& .MuiInputBase-input": {
      paddingLeft: 15,
      paddingRight: 5,
      paddingTop: 10,
      paddingBottom: 10,
    },
    "& .MuiInputAdornment-root": {
      marginLeft: 0,
      marginRight: 0,
      "& .MuiIconButton-root": {
        padding: 0,
        paddingLeft: 0,
      },
    },
  },
  "& label.Mui-focused": {
    color: "green",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#fd954f",
    },
    "&:hover fieldset": {
      borderColor: "#fd954f",
      borderWidth: 2,
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fd954f",
      borderWidth: 2,
    },
  },
});

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  max-width: 100%;
  flex-wrap: wrap;
`;

export const Title = styled.div`
  font-size: 23px;
  margin-right: 10px;
`;
